import r from "../../../tailwindConfig/colors/index.js";
import i from "../../../utilities/tw.js";
const o = "--fa-primary-color", a = "--fa-secondary-color", c = "--fa-primary-opacity", t = "--fa-secondary-opacity", s = {
  base: i`size-4`,
  variant: {
    primary: {
      [o]: r.neutral.inverse,
      [a]: r.primary.DEFAULT,
      [c]: "0.25",
      [t]: "1.0"
    },
    secondary: {
      [o]: r.neutral.DEFAULT,
      [a]: r.neutral.DEFAULT,
      [c]: "0.5",
      [t]: "1.0"
    }
  }
};
export {
  s as iconStyles
};
